module.exports = __webpack_public_path__ + "iconoRecepcion512.png";